/**** session clear when user enter from menue start  ****/
setTimeout(function(){        
    jQuery(".list-unstyled li").click(function() {     
       // alert();
      localStorage.clear();
    });
}, 500);  
